<div class="govuk-grid-row">

  <div class="govuk-grid-column-two-thirds">
    <h2 class="govuk-heading-l">Questions</h2>

    <ng-container  *ngIf="initialized">
      <div *ngFor="let q of treePath; index as i" #treeItem [ngClass]="{active: !q.selectedResponse, highlight:!q.noHighlight }">

        <!-- Question -->
        <div class="govuk-grid-row govuk-body item item-left" >

          <div class="govuk-grid-column-full" >
            <a role="button" class="item-content question govuk-body"
               *ngIf="q.selectedResponse; else activeQuestion"
               [id]="q.slug"
               [routerLink]="q.questionHref"
               title="Undo question response: {{q.text}}">{{q.text}}</a>

            <ng-template #activeQuestion>
              <h3 class="item-content question govuk-body theme-border" [id]="q.slug">{{q.text}}</h3>
            </ng-template>

            <div *ngIf="q.info && q.showInfo" class="question-info govuk-body-s caption" [innerHtml]="q.info"></div>
          </div>
        </div>

        <!-- Responses -->
        <div class="govuk-grid-row govuk-body" >
          <div class="govuk-grid-column-full item item-right" *ngIf="q.selectedResponse; else responseList">
            <p class="item-content response">
              {{q.selectedResponse.text}}
            </p>
          </div>

          <ng-template #responseList>

            <aa-response-list [labelledBy]="q.slug" [responses]="visibleResponses" class="govuk-grid-column-full"></aa-response-list>

          </ng-template>
        </div>
      </div>

      <div class="advice-button active" *ngIf="error" #treeItem>
        <p class="govuk-body">
          <b>Sorry!</b> {{error}}
        </p>
      </div>

      <div class="advice-button active" *ngIf="adviceHref" #treeItem>
        <p class="govuk-body">
          Thank you for completing the questions.
          <!-- Removed 17/06/2020 based on feedback from PM
          <br>
          If you are happy with the answers you have given, please click <b>View Advice</b>.
          -->
        </p>

        <ng-container *ngIf="externalHostName; else internalLink">
          <a (click)="adviceClick()" [href]="adviceHref" role="button" draggable="false" class="govuk-button govuk-button--start govuk-!-margin-top-2 theme-button">
            View Advice
            <svg class="govuk-button__start-icon" xmlns="http://www.w3.org/2000/svg" width="17.5" height="19" viewBox="0 0 33 40" role="presentation" focusable="false">
              <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z" />
            </svg>
          </a>

          <p class="govuk-body">
            Please note that this advice is provided on an a different website <b>{{externalHostName}}</b>
          </p>
        </ng-container>

        <ng-template #internalLink>
          <a (click)="adviceClick()" [routerLink]="adviceHref" [state]="adviceState" role="button" draggable="false" #adviceButton class="govuk-button govuk-button--start govuk-!-margin-top-2 theme-button">
            View Advice
            <svg class="govuk-button__start-icon" xmlns="http://www.w3.org/2000/svg" width="17.5" height="19" viewBox="0 0 33 40" role="presentation" focusable="false">
              <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z" />
            </svg>
          </a>
        </ng-template>

        <!-- Removed 17/06/2020 based on feedback from PM
        <p class="govuk-body">
          If you would like to change your answers click <b (click)="navigation.back()">Back</b>
        </p>
        -->

      </div>
    </ng-container>
  </div>

  <div class="govuk-grid-column-one-third" *ngIf="popularTopics">
    <div class="theme-border side-panel">

      <!-- Related Items -->
      <aside class="related-items govuk-!-margin-bottom-5" role="complementary">
        <h2 class="govuk-heading-m" id="related-items-title">
         Popular Topics
        </h2>

        <nav role="navigation" aria-labelledby="related-items-title">
          <ul class="govuk-list govuk-!-font-size-16">
            <li *ngFor="let item of popularTopics">

              <ng-container *ngIf="item.responseHref; else invalidLink">

                <!-- external links -->
                <a class="theme-link left-border theme-border" [routerLink]="item.responseHref">
                  {{item.text}}
                </a>
              </ng-container>

              <!-- invalid links -->
              <ng-template #invalidLink>
                <a>{{item.text}}</a>
              </ng-template>
            </li>
          </ul>
        </nav>
      </aside>
    </div>
  </div>
</div>
